import { Mcc } from 'app/model/cris/mcc';
import { ModelPrepped, ModelWithoutId } from 'app/type';

import { RestfulApiService } from '../restful-api.service';

class MccService extends RestfulApiService<Mcc> {
    protected getFormName(): string {
        return 'mcc';
    }

    protected getPath(): string {
        return 'mccs';
    }

    protected prepareSaveData(entity: ModelWithoutId<Mcc>): ModelPrepped<Mcc> {
        return {
            ...entity,
            dateCreated: undefined,
            dateEdited: undefined,
        };
    }
}

export const mccService = new MccService();
